
<div class="modal-header">
    <span class="modal-header-title">{{ 'EMPLOEE.INVITE_EMPLOEE' | translate }}</span>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
    </button>
</div>
<div class="modal-body">


    <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">
    
        <div class="row">
            <div class="col-6">
    
                <div class="form-group">
                    <label for="email"><span class="star">*</span> Email</label>
                    <input type="email" class="form-control" id="email" formControlName="email">
                    <div *ngIf="errorMessages">
                        <div *ngFor="let item of errorMessages.email">
                            <div class="text-error" *ngIf="validation('email', item.type)">
                                {{ item.message | translate: item.options }}
                            </div>
                        </div>
                    </div>
                </div>
    
            </div>
            <div class="col-6">
    
                <div class="form-group">
                    <label for="full_name"><span class="star">*</span> {{ 'USERS.USERS_EDITOR.FIRST_NAME' | translate }}</label>
                    <input type="text" class="form-control" id="full_name" formControlName="full_name">
                    <div *ngIf="errorMessages">
                        <div *ngFor="let item of errorMessages.full_name">
                            <div class="text-error" *ngIf="validation('full_name', item.type)">
                                {{ item.message | translate: item.options }}
                            </div>
                        </div>
                    </div>
                </div>
    
            </div>

            <div class="col-12">

                <div class="form-group">
                    <label for="urole_id"><span class="star">*</span> {{ 'ROLE' | translate }}</label>
                    <select class="form-control" id="urole_id" formControlName="urole_id">
                        <option *ngFor="let urole of uroles" [value]="urole.id">{{ urole.name }}</option>
                    </select>
                    <div *ngIf="errorMessages">
                        <div *ngFor="let item of errorMessages.urole_id">
                            <div class="text-error" *ngIf="validation('urole_id', item.type)">
                                {{ item.message | translate: item.options }}
                            </div>
                        </div>
                    </div>
                </div>
    
            </div>

            <div class="col-6">
                <div class="form-group">
                    <label for="department"> {{ 'EMPLOEE.DEPARTMENT' | translate }}</label>
                    <ng-select  
                        id="department"
                        class="custom" 
                        clearAllText="{{ 'CLEAR' | translate }}"
                        notFoundText="{{ 'NO_DATA' | translate }}"
                        bindLabel="name"
                        bindValue="id"
                        formControlName="department_id"
                        [loading]="loading"
                        [items]="departments"
                        >
                    </ng-select>
                </div>
            </div>   

            <div class="col-6">
    
                <div class="form-group">
                    <label for="position"> {{ 'EMPLOEE.POSITIONS' | translate }}</label>
                    <ng-select  
                        id="position"
                        class="custom" 
                        clearAllText="{{ 'CLEAR' | translate }}"
                        notFoundText="{{ 'NO_DATA' | translate }}"
                        bindLabel="name"
                        bindValue="id"
                        formControlName="position_id"
                        [loading]="loading"
                        [items]="positions"
                        >
                    </ng-select>
                </div>
            </div>
        </div>

    </form>

</div>
<div class="modal-footer btn-box">
    <button type="button" class="btn btn-primary btn-sm" (click)="onSend()" [disabled]="form.invalid">{{ 'SEND'| translate }}</button>
    <button type="button" class="btn btn-light btn-sm" (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate }}</button>
</div>